/**
 * Get browser/system info for session logging.
 * Always returns at least userAgent, platform, language (available in all browsers).
 * Adds highEntropyVals (architecture) when User-Agent Client Hints API is available.
 */
export default async function getBrowserInfoForDb() {
  const base = {
    userAgent: navigator.userAgent,
    platform: navigator.platform,
    language: navigator.language,
  };

  try {
    const highEntropyVals =
      await window.navigator?.userAgentData?.getHighEntropyValues([
        "architecture",
      ]);
    return { ...base, highEntropyVals };
  } catch {
    return base;
  }
}
